import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'

// Define a service using a base URL and expected endpoints
export const tarifApi = createApi({
  reducerPath: 'tarifApi',
  baseQuery: fetchBaseQuery({
    baseUrl: 'https://onza-api.ibm.kg/api/tarif/',
    prepareHeaders: (headers, { getState }) => {
      let { auth: { auth } } = getState()
      if (typeof auth == "string") {
        auth = JSON.parse(auth)
      }
      headers.set("Authorization", `Bearer ${auth?.accessToken}`);
      return headers;
    },
  }),
  tagTypes: ["tarif"],
  endpoints: (builder) => ({
    getTarif: builder.query({
      query: () => `tarifList`,
      providesTags: ["tarif"],
    }),
    createOrUpdateTarif: builder.mutation({
      query: (formData) => {
        return {
          url: `createEditTarif`,
          method: 'post',
          body: formData
        }
      },
      invalidatesTags: ["tarif"],
    }),
    deleteTarif: builder.mutation({
      query: (guid) => {
        return {
          url: `deleteTarif`,
          method: 'DELETE',
          params: { tarif_guid: guid },
        }
      },
      invalidatesTags: ["tarif"],
    })
  }),
})

export const { useGetTarifQuery, useCreateOrUpdateTarifMutation, useDeleteTarifMutation } = tarifApi